import React, { ReactNode } from 'react'
import { FormInterface } from '../../types/entities/form-interface'
import { CommonFormUi } from './ui/common-form-ui'
import {
  FormSuccessOptInScreenContainerBottomPaddingUi,
  FormSuccessOptInScreenContainerTopPaddingUi,
  FormSuccessOptInScreenContainerUi,
} from './ui/form-success-opt-in-screen-container-ui'
import { FormSuccessOptInScreenHeaderUi } from './ui/form-success-opt-in-screen-header-ui'
import { FormSuccessOptInScreenIconUi } from './ui/form-success-opt-in-screen-icon-ui'
import { FormSuccessOptInScreenOverlayUi } from './ui/form-success-opt-in-screen-overlay-ui'
import { FormSuccessOptInScreenTextUi } from './ui/form-success-opt-in-screen-text-ui'

export interface CommonFormProps {
  entity: FormInterface
  successOptInScreen: {
    fontSize: number | undefined
    mobileFontSize: number | undefined
    headerFontSize: number | undefined
    headerMobileFontSize: number | undefined
    textColor: string | undefined
    mobileTextColor: string | undefined
  }
  isSuccessOptInScreenOpened: boolean | undefined
  children: ReactNode
}

export const CommonForm = ({
  children,
  entity,
  successOptInScreen,
  isSuccessOptInScreenOpened,
}: CommonFormProps) => {
  return (
    <CommonFormUi
      layout={entity.layout}
      rowGap={entity.rowGap}
      mobileRowGap={entity.mobileRowGap}
      columnGap={entity.columnGap}
      border={entity.border}
      mobileBorder={entity.mobileBorder}
      padding={entity.padding}
      mobilePadding={entity.mobilePadding}
      backgroundColor={entity.backgroundColor}
      mobileBackgroundColor={entity.mobileBackgroundColor}
    >
      {children}
      {isSuccessOptInScreenOpened && (
        <FormSuccessOptInScreenOverlayUi
          padding={entity.padding}
          mobilePadding={entity.mobilePadding}
          backgroundColor={entity.backgroundColor}
          mobileBackgroundColor={entity.mobileBackgroundColor}
          border={entity.border}
          mobileBorder={entity.mobileBorder}
          borderRadius={entity.border?.radius}
          mobileBorderRadius={entity.mobileBorder?.radius}
        >
          <FormSuccessOptInScreenContainerTopPaddingUi />
          <FormSuccessOptInScreenContainerUi
            padding={entity.padding}
            mobilePadding={entity.mobilePadding}
            backgroundColor={
              entity.action.successOptInScreen?.backgroundColor ||
              entity.backgroundColor
            }
            mobileBackgroundColor={
              entity.action.successOptInScreen?.mobileBackgroundColor ||
              entity.mobileBackgroundColor
            }
            borderRadius={entity.border?.radius}
            mobileBorderRadius={entity.mobileBorder?.radius}
          >
            <FormSuccessOptInScreenIconUi
              iconColor={entity.action.successOptInScreen?.iconColor}
              mobileIconColor={
                entity.action.successOptInScreen?.mobileIconColor
              }
            />
            <FormSuccessOptInScreenHeaderUi
              fontSize={successOptInScreen.headerFontSize || 30}
              mobileFontSize={successOptInScreen.headerMobileFontSize || 20}
              color={successOptInScreen.textColor}
              mobileColor={successOptInScreen.mobileTextColor}
            >
              {entity.action.successOptInScreen?.headingText}
            </FormSuccessOptInScreenHeaderUi>
            <FormSuccessOptInScreenTextUi
              fontSize={successOptInScreen.fontSize}
              mobileFontSize={successOptInScreen.mobileFontSize}
              color={successOptInScreen.textColor}
              mobileColor={successOptInScreen.mobileTextColor}
            >
              {entity.action.successOptInScreen?.text}
            </FormSuccessOptInScreenTextUi>
          </FormSuccessOptInScreenContainerUi>
          <FormSuccessOptInScreenContainerBottomPaddingUi
            padding={entity.padding}
            mobilePadding={entity.mobilePadding}
          />
        </FormSuccessOptInScreenOverlayUi>
      )}
    </CommonFormUi>
  )
}
